import moment, { Moment } from "moment";
import { useEffect, useState } from "react";

const DEFAULT_INTERVAL_MS = 60_000;

export const useCurrentMoment = (intervalMs: number = DEFAULT_INTERVAL_MS): Moment => {
  const [now, setNow] = useState<Moment>(() => moment());

  useEffect(() => {
    const handle = setInterval(() => setNow(moment()), intervalMs);
    return () => clearInterval(handle);
  }, [intervalMs]);

  return now.clone();
};
